import React from "react";
import PropTypes from "prop-types";
import { IconButton, Link, Typography } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { ExternalLink } from "../../../components/Icons/ExternalLink";

const useStyles = makeStyles((theme) => ({
  textPrimary: {
    color: theme.palette.text.primary,
  },
}));

export default function PaymentProfileLink({ url, label, testId }) {
  const theme = useTheme();
  const classes = useStyles(theme);
  return (
    <Link
      style={{ display: "flex", alignItems: "center", marginLeft: "12px", marginRight: "12px" }}
      target="_blank"
      rel="noopener noreferrer"
      href={url}
      data-testid={testId}
    >
      <Typography variant="button" className={classes.textPrimary}>
        {label.toUpperCase()}
      </Typography>
      <IconButton size="small" style={{ marginLeft: "9px", padding: "0px" }}>
        <ExternalLink />
      </IconButton>
    </Link>
  );
}

PaymentProfileLink.propTypes = {
  url: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  testId: PropTypes.string,
};

PaymentProfileLink.defaultProps = {
  testId: "",
};
